import { post } from "@/api/http";

export default {
  // AI指令集相關 API (AIPromptCollectionController)
  
  // 創建指令集
  createCollection: function (data) {
    return post("/AIPromptCollection/create-collection", data);
  },
  
  // 創建預設指令集（首次創建）
  createDefaultCollection: function (data) {
    return post("/AIPromptCollection/create-default", data);
  },
  
  // 更新指令集
  updateCollection: function (data) {
    return post("/AIPromptCollection/update-collection", data);
  },
  
  // 根據創建者取得收藏集列表
  getCollectionsByCreator: function (data) {
    return post("/AIPromptCollection/get-collections-by-creator", data);
  },
  
  // 刪除餐盤（級聯刪除內部指令）
  deleteCollection: function (data) {
    return post("/AIPromptCollection/delete-collection", data);
  },
  
  // 取得餐盤內指令數量（用於前端檢查）
  getCollectionPromptCount: function (data) {
    return post("/AIPromptCollection/get-prompt-count", data);
  },

  // AI指令相關 API (AIPromptController)
  
  // 創建AI指令
  createPrompt: function (data) {
    return post("/AIPrompt/create-prompt", data);
  },
  
  // 更新AI指令
  updatePrompt: function (data) {
    return post("/AIPrompt/update-prompt", data);
  },
  
  // 刪除AI指令
  deletePrompt: function (data) {
    return post("/AIPrompt/delete-prompt", data);
  },
  
  // 取得收藏集中的所有AI指令
  getPromptsByCollection: function (data) {
    return post("/AIPrompt/get-prompts-by-collection", data);
  },
  
  // 驗證管理員權限
  verifyAdmin: function (data) {
    return post("/AIPrompt/verify-admin", data);
  },
  
  // 從 main.js 提取的 API
  verifyAdminAccess: function (data) {
    return post("/AIPrompt/verify-admin", data);
  },
  
  // 取得 AI Prompt SAS Token
  getAIPromptSasToken: function () {
    return post("/aiprompt/sas");
  },

  // 通過分享代碼取得餐盤及其指令
  getCollectionByShareCode: function (data) {
    return post("/AIPromptCollection/get-by-share-code", data);
  }
};